// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { NodeWithI18n } from "@angular/compiler";

export const environment = {
  production: false,
  inMemoryWebApi: false,
   baseUrl2ApiCalls: 'http://localhost:58437/',
   isProduction:true
  //baseUrl2ApiCalls: 'http://devhinuch2012.ntdomain.educ.gov.il/Idm.SelfServices/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
